<template>
  <div class="communication-section">
    <div class="communication-title"></div>
    <div class="mobile-tag-list" v-if="isMobile">
      <div
        class="tag-item"
        v-for="(item, index) in tabList"
        :key="index"
        :class="[`tag-${index + 1}`, { active: item === currentTab }]"
        @click="switchComTab(item)"
      ></div>
    </div>
    <div class="book" :class="`book-${currentTab}`">
      <div class="tag-list" v-if="!isMobile">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          class="tag-item btns"
          :class="[`tag-${index + 1}`, { active: item === currentTab }]"
          @click="switchComTab(item)"
        ></div>
      </div>
      <div class="check-btn btns" @click="handleViewClick"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
const emit = defineEmits(["switch-com-tab", "showKolPopup"]);
const tabList = ["feedback", "development", "kol"];
const isMobile = inject("isMobile", ref(false));

// 当前选中的页签
const currentTab = ref("feedback");

const tabMap = {
  feedback: "精选玩家心声",
  development: "开发者札记",
  kol: "加入创作者团队",
}
// 页签切换只改变视觉状态，不触发功能
const switchComTab = (tab) => {
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: tabMap[tab],
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  currentTab.value = tab;
};

// 查看按钮点击时才触发对应功能
const handleViewClick = () => {
  const tab = currentTab.value;
  if (tab === "feedback") {
    emit("switch-com-tab", "feedback");
    return;
  }
  if (tab === "kol") {
    emit("showKolPopup");
    return;
  }
  emit("switch-com-tab", tab);
};
</script>

<style scoped lang="less">
.mobile-tag-list {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100px;
  .tag-item {
    width: 220px;
    height: 60px;
    background-color: #fff;
    border-radius: 10px;
    cursor: pointer;
  }
  .tag-1 {
    background: url("@images/communication/btn-1_m.png") center/contain
      no-repeat;
    &.active {
      background: url("@images/communication/btn-1-active_m.png") center/contain
        no-repeat;
    }
  }
  .tag-2 {
    background: url("@images/communication/btn-2_m.png") center/contain
      no-repeat;
    &.active {
      background: url("@images/communication/btn-2-active_m.png") center/contain
        no-repeat;
    }
  }
  .tag-3 {
    background: url("@images/communication/btn-3_m.png") center/contain
      no-repeat;
    &.active {
      background: url("@images/communication/btn-3-active_m.png") center/contain
        no-repeat;
    }
  }
}
.book {
  position: relative;
  margin-top: 40px;
  width: 1400px;
  height: 900px;
  margin: 0 auto;
  @media (orientation: portrait) {
    width: 720px;
    height: 500px;
  }

  // feedback页签的背景图
  &.book-feedback {
    background: url("@images/communication/book-1.png") center/contain no-repeat;
    @media (orientation: portrait) {
      background: url("@images/v3-m/com/book-1.png") center/contain no-repeat;
    }
  }

  // development页签的背景图
  &.book-development {
    background: url("@images/communication/book-2.png") center/contain no-repeat;
    @media (orientation: portrait) {
      background: url("@images/v3-m/com/book-2.png") center/contain no-repeat;
    }
  }

  // kol页签的背景图
  &.book-kol {
    background: url("@images/communication/book-3.png") center/contain no-repeat;
    @media (orientation: portrait) {
      background: url("@images/v3-m/com/book-3.png") center/contain no-repeat;
    }
  }

  .tag-list {
    position: absolute;
    left: -140px;
    top: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    .tag-item {
      width: 200px;
      height: 100px;
      background-color: #fff;
      border-radius: 10px;
      cursor: pointer;
      position: relative;
    }
    .tag-1 {
      background: url("@images/communication/btn-1.png") center/contain
        no-repeat;
      &.active {
        background: url("@images/communication/btn-1-active.png") center/contain
          no-repeat;
      }
    }
    .tag-2 {
      left: -10px;
      background: url("@images/communication/btn-2.png") center/contain
        no-repeat;
      &.active {
        background: url("@images/communication/btn-2-active.png") center/contain
          no-repeat;
      }
    }
    .tag-3 {
      left: -15px;
      background: url("@images/communication/btn-3.png") center/contain
        no-repeat;
      &.active {
        background: url("@images/communication/btn-3-active.png") center/contain
          no-repeat;
      }
    }
  }
  .check-btn {
    position: absolute;
    left: 140px;
    bottom: 300px;
    width: 300px;
    height: 100px;
    background: url("@images/communication/check.png") center/contain no-repeat;
    transition: transform 0.5s ease;
    cursor: pointer;

    @media (orientation: portrait) {
      width: 150px;
      height: 70px;
      bottom: 140px;
      left: 100px;
    }
  }
}
</style>
